import {NgModule} from '@angular/core';
import {IonicPageModule} from 'ionic-angular';
import {TermsPage} from './terms';

@NgModule({
  declarations: [
    TermsPage,
  ],
  imports: [
    IonicPageModule.forChild(TermsPage),
  ],
  exports: [
    TermsPage
  ]
})
export class TermsPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/terms/terms.module.ts